class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  /* True when accordion.js animates this panel — the signal to hand it the
     open/close writes instead of touching `open` directly. */
  get animated() {
    return Boolean(window.Theme?.disclosure?.owns(this.mainDetailsToggle));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    /* accordion.js drives this panel in both directions and the stock reveal
       keyframes are switched off for it (component-accordion-animation.css), so
       there is nothing here left to play. Collecting animations anyway would
       capture accordion.js's own animation and hand it to cancel() on the next
       close, stranding the panel open with `open` still set. */
    if (this.animated) return;

    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    /* Through accordion.js where it owns the panel, so closing on focus-out
       fades out the same way clicking the summary does. */
    if (this.animated) {
      window.Theme.disclosure.setOpen(this.mainDetailsToggle, false);
    } else {
      this.mainDetailsToggle.removeAttribute('open');
    }

    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
